/**
 * Panel definitions for flex/balancing segment
 * Add your balancing-related panels here based on backend dataset configs
 */
import { applyCountryFilterToPanels } from './countryContext';

const basePanels = [
  // First row: 1 panel full width (24 cols)
  {
    id: 'entsoe-capacity-fees',
    type: 'datasetChart',
    datasetId: 'entsoe-afrr',
    visualizationId: 'capacity-fees-chart',
    gridPos: { x: 0, y: 0, w: 24, h: 20 },
  },
];

export const flexBalancingPanels = ({ country } = {}) =>
  applyCountryFilterToPanels(basePanels, country);
